import { IconTrash } from "@tabler/icons-react";
import { Button, message, Popconfirm, Tooltip } from "antd";
import { useAPI } from "../../hooks/useAPI";
import { ENDPOINTS } from "../../constants/endpoints.constant";

import { deleteCall } from "../../constants/apicalls.constant";
import { useNavigate } from "react-router";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedEventList } from "../../store/slices/event.slice";
import { RootState } from "../../store/store";
import DeleteModal from "../DeleteModal";

const DeleteEvent = ({
  id,
  child = false,
  bg = true,
}: {
  id: string;
  child: boolean;
  bg?: boolean;
}) => {
  const { error, loading, trigger } = useAPI<{
    status: boolean;
    message: string;
    data: {
      force_delete?: boolean;
      refund_processing?: boolean;
    } | null;
  }>(ENDPOINTS.event);

  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const dispatch = useDispatch();
  const event = useSelector((state: RootState) => state.event);
  const onDelete = async (forceDelete?: boolean) => {
    const res = await trigger(
      deleteCall(id!, forceDelete ? { force_delete: true } : {}),
    );

    if (!res?.status) {
      message.error(res?.message || "Failed to delete event");
      return;
    }

    if (res.data?.force_delete) {
      setIsOpen(true);
      return;
    }

    setIsOpen(false);

    if (!child) navigate("/");
    if (child) {
      const children = event?.children?.filter((data) => data.id !== id);
      dispatch(
        setSelectedEventList({
          ...event,
          steps_info:
            event?.steps_info && children?.length === 0
              ? event?.steps_info.filter(
                  (data) => data === "basic_info" || data === "media",
                )
              : event.steps_info,
          children: children,
        }),
      );
    }

    message.success(
      res.data?.refund_processing
        ? res.message || "Event deleted. Refunds are being processed."
        : res.message || "Event deleted successfully",
    );
  };

  if (error) return <>Something went wrong</>;
  return (
    <>
      <Tooltip title="Delete this event">
        <Popconfirm
          title="Are you sure you want to delete this event?"
          onConfirm={() => onDelete(false)}
          okText="Yes"
          cancelText="No"
        >
          <Button
            // type="text"
            variant="filled"
            className={`${!bg ? "!bg-transparent hover:!bg-black/3" : ""}`}
            color="red"
            danger
            size="small"
            shape="circle"
            loading={loading}
            icon={<IconTrash size={15} />}
          />
        </Popconfirm>
      </Tooltip>
      <DeleteModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        onDelete={onDelete}
        loading={loading}
      />
    </>
  );
};

export default DeleteEvent;
